import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M2.5 4v3h5v12h3V7h5V4h-13zm19 5h-9v3h3v7h3v-7h3V9z"
}), 'TextFieldsSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/TextFieldsSharp.js
// module id = 6712
// module chunks = 2